import L from "leaflet";
import * as d3 from "d3";
import $ from "jquery";
import { svgIconExtends } from "./SvgIcon";
import configurationUtils from "../../../../utils/IconConfiguration";

L.ClusterIcon = svgIconExtends.extend({
  options: {
    className: "cluster-svg-icon",
    id: "",
    width: 30,
    count: 123,
    alertSeverity: null,
    motion: null,
  },

  createIcon: function () {
    var div = document.createElement("div"),
      options = this.options;

    div.id = "svg-icon-" + options.id;
    div.name = options.state;

    if (options.svgString) {
      this._createSvg(options.svgString, div);
    } else {
      let width = options.width;
      // Create SVG string using D3
      const svg = d3
        .create("svg")
        .attr("width", width)
        .attr("height", width)
        .attr("viewBox", `0 0 ${width} ${width}`)
        .attr("shape-rendering", "geometricPrecision");

      const center = width / 2;
      const radius = width / 2 - 1;
      const innerRadius = width / 2 - 3;
      const centerRadius = width / 2 - 5;

      // Main circle group
      const mainGroup = svg
        .append("g")
        .attr("transform", `translate(${center},${center})`);

      // Create arc generators
      const backgroundArc = d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius(radius)
        .startAngle(0)
        .endAngle(2 * Math.PI)
        .cornerRadius(2);

      const progressArc = d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius(radius)
        .startAngle(0)
        .endAngle((options.motion / 100) * 2 * Math.PI)
        .cornerRadius(2);

      // Draw background circle
      mainGroup
        .append("path")
        .attr("d", backgroundArc)
        .attr("fill", "#304269")
        .style("stroke", "#304269")
        .style("stroke-width", "0.5px");

      // Draw progress arc if motion is set
      if (options.motion !== 0 && options.motion !== null) {
        mainGroup
          .append("path")
          .attr("d", progressArc)
          .attr("fill", "#39CB99")
          .style("stroke", "#39CB99")
          .style("stroke-width", "0.5px");
      }

      // Add center number with background circle
      const textGroup = mainGroup.append("g");

      textGroup
        .append("circle")
        .attr("id", "cluster-bg")
        .attr("r", centerRadius)
        .attr("fill", "#304269");

      textGroup
        .append("text")
        .attr("id", "cluster-text")
        .style("text-anchor", "middle")
        .style("dominant-baseline", "central")
        .style("font-size", "11px")
        .style("font-weight", "bold")
        .style("font-family", "Arial, sans-serif")
        .text(options.count.toString());

      // Add bell if alert is true
      if (options.alertSeverity !== null) {
        const bellGroup = mainGroup
          .append("g")
          .attr(
            "transform",
            `translate(${-radius * 1.5}, ${-radius * 2.2}) scale(${
              (width / 36) * 1.5
            })`
          );

        let alertbgColor = configurationUtils.getAlertColor(
          options.alertSeverity
        );
        bellGroup
          .append("path")
          .attr(
            "d",
            "M10.6 12.8C10.6 12.36 10.3 12 10 12C9.7 12 9.4 12.36 9.4 12.8V13.664C7.928 14.048 6.2 16.024 6.2 18.4V21.2L5.4 22H14.6L13.8 21.2V18.4C13.8 16.024 12.072 14.048 10.6 13.664V12.8ZM10 23.6C10.8 23.6 11.2 23 11.2 22.4H8.8C8.8 23 9.2 23.6 10 23.6Z"
          )
          .attr("fill", alertbgColor);
      }

      // Convert D3 SVG to string
      const svgString = svg.node().outerHTML;
      this._createSvg(svgString, div);
    }

    if (options.bgPos) {
      var bgPos = L.point(options.bgPos);
      div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
    }
    this._setIconStyles(div, "icon");
    return div;
  },

  setStyle: function (el, style) {
    var options = this.options;
    var iconInfo =
      options.className === "cluster-svg-infras"
        ? configurationUtils.getIcon("cluster_infras")
        : options.className === "cluster-svg-geozone"
        ? configurationUtils.getIcon("cluster_geozone")
        : options.className === "cluster-svg-sitemap"
        ? configurationUtils.getIcon("cluster_sitemap")
        : configurationUtils.getIcon("cluster");

    switch (style) {
      case "normal":
        $(el).find('[id^="cluster-bg"]').attr("fill", iconInfo.bgColor);
        $(el).find('[id^="cluster-fg"]').attr("stroke", iconInfo.iconColor);
        $(el).find('[id^="cluster-text"]').attr("fill", iconInfo.iconColor);
        break;
      case "hover":
        $(el).find('[id^="cluster-bg"]').attr("fill", iconInfo.bgHoverColor);
        $(el)
          .find('[id^="cluster-fg"]')
          .attr("stroke", iconInfo.iconHoverColor);
        $(el)
          .find('[id^="cluster-text"]')
          .attr("fill", iconInfo.iconHoverColor);
        break;
    }
  },
  onEnter: function () {},

  onLeave: function () {},

  onClick: function () {},

  beforeInject: function (img, svg) {
    var self = this;
    var svg3 = d3.select(svg);

    svg3.attr("width", self.options.width);
    svg3.attr("height", self.options.width);
    svg3.attr(
      "viewBox",
      "0 0 " + self.options.width + " " + self.options.width
    );

    svg3.select('[id^="cluster-bg"]').attr("cx", self.options.width / 2);
    svg3.select('[id^="cluster-bg"]').attr("cy", self.options.width / 2);
    svg3.select('[id^="cluster-bg"]').attr("r", self.options.width / 2 - 1);

    svg3.select('[id^="cluster-fg"]').attr("cx", self.options.width / 2);
    svg3.select('[id^="cluster-fg"]').attr("cy", self.options.width / 2);
    svg3.select('[id^="cluster-fg"]').attr("r", self.options.width / 2 - 3);

    svg3.select('[id^="cluster-text"]').text(self.options.count + "");
  },
});

L.clusterIcon = function (opts) {
  var width = 32;
  if (opts.count >= 100 && opts.count < 1000) {
    width = 40;
  } else if (opts.count >= 1000) {
    width = 48;
  }
  return new L.ClusterIcon(
    Object.assign(opts, {
      width: width,
      id: opts.id,
      iconAnchor: [width / 2, width / 2],
    })
  );
};

export const ClusterIcon = L.clusterIcon;
